
export default "/assets/exclamation-triangle-micro.725856a2.svg"